import { cx } from '../../cx'
import { Star } from './star'

type StarRatingProps = {
  stars?: number | null
  hideLabel?: boolean
  label?: string
  yellow?: boolean
}

export function StarRating({ stars, hideLabel, label, yellow }: StarRatingProps) {
  if (!stars || !Number.isFinite(stars) || stars < 0) return null

  const wholeStars = Math.floor(stars)
  const fullStarNumbers = Array.from({ length: wholeStars }, (_, index) => index + 1)
  const partialFill = Math.round((stars - wholeStars) * 100)

  return (
    <span className="inline-flex items-center gap-1">
      <span className="inline-flex gap-0.5" aria-hidden>
        {fullStarNumbers.map(starNumber => (
          <Star key={starNumber} className={cx('inline size-4', yellow && 'text-ocker')} />
        ))}
        {partialFill > 0 && <PartialStar fill={partialFill} yellow={yellow} />}
      </span>
      {!hideLabel && (
        <span className="font-base-copy">
          {label || `${stars} ${stars === 1 ? 'Stern' : 'Sterne'}`}
        </span>
      )}
    </span>
  )
}

function PartialStar({ fill, yellow }: { fill: number; yellow?: boolean }) {
  return (
    <span
      className={cx('relative inline-block size-4', yellow && 'text-ocker')}
      data-star-fill={fill}
    >
      <Star className="absolute inset-0 size-4 opacity-20" />
      <span className="absolute inset-y-0 left-0 overflow-hidden" style={{ width: `${fill}%` }}>
        <Star className="size-4 max-w-none" />
      </span>
    </span>
  )
}
